import axios from "axios";
import { ICartao } from "shared/interfaces/IMetodo";

interface ICardRequest {
  type: "card";
  card: {
    number: string;
    holder_name: string;
    holder_document: string;
    exp_month: number; //Mês de validade do cartão. Valor entre 1 e 12
    exp_year: number; //Ano de validade do cartão. Formatos yy ou yyyy. Ex: 23 ou 2023.
    cvv: string; //Código de segurança do cartão. O campo aceita 4 ou 3 caracteres, variando por bandeira.
  };
}

export const pagarmeApi = axios.create({
  baseURL: process.env.REACT_APP_PAGARME_URL,
});
export async function criarTokenCartao(
  dadosCartao: ICartao,
): Promise<string | void> {
  const [expMonth, expYear] = dadosCartao.validade.split("/").map(Number);
  const cardToTokenize = {
    type: "card",
    card: {
      number: dadosCartao.numero.replace(/\s/g, ""),
      holder_name: dadosCartao.nome,
      holder_document: dadosCartao.documento,
      exp_month: expMonth,
      exp_year: expYear,
      cvv: dadosCartao.cvv,
    },
  } satisfies ICardRequest;

  const pagarmeResponse = await pagarmeApi.post("/tokens", cardToTokenize, {
    params: { appId: process.env.REACT_APP_PAGARME_PUBLIC_KEY },
  });

  if (pagarmeResponse.status === 200) {
    return pagarmeResponse.data.id;
  }
}
